import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=6b17bcca&"
import script from "./materials.vue?vue&type=script&lang=ts&"
export * from "./materials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b17bcca')) {
      api.createRecord('6b17bcca', component.options)
    } else {
      api.reload('6b17bcca', component.options)
    }
    module.hot.accept("./materials.vue?vue&type=template&id=6b17bcca&", function () {
      api.rerender('6b17bcca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/education/material/materials.vue"
export default component.exports